export default "__VITE_ASSET__0fd60c43__"